import React from 'react';

import MomentPropTypes from "../../helpers/MomentPropTypes";
import { translate as t } from '../../lib/I18n';


function FareValidity ({ from, to }) {
    return (
        <div className="margin-top--sm">
            <div className="text-sm text-weight--normal clearfix">
                <div className="fix-width text-light pull-left">{ t('order.summary.validFrom') }</div>
                <div className="pull-left">{ from.format('dddd DD MMMM YYYY') }</div>
            </div>
            <div className="text-sm text-weight--normal clearfix">
                <div className="fix-width text-light pull-left">{ t('order.summary.validTo') }</div>
                <div className="pull-left">{ to.format('dddd DD MMMM YYYY') }</div>
            </div>
        </div>
    );
}

FareValidity.propTypes = {
    from: MomentPropTypes.isMoment,
    to: MomentPropTypes.isMoment
};


export default FareValidity;



// WEBPACK FOOTER //
// ./src/components/fares/FareValidity.js